import React, { useState, useEffect } from 'react';
import { firestore } from '../config/firebaseConfig';
import {
  doc,
  setDoc,
  updateDoc,
  collection,
  getDocs,
  deleteDoc,
  Timestamp,
  // deleteField, // Não precisamos importar se não for para remover explicitamente um campo
} from 'firebase/firestore';
import QuestaoList from './QuestaoList';
import ImportQuestoes from '../components/ImportQuestoes';
import './Questoes.css';
import Carregando from '../components/Carregando';
import Modal from 'react-modal';
import Simulador from '../components/Simulador';

const ITEMS_PER_PAGE_OPTIONS = [5, 10, 20];

const getOptionLetter = (index) => {
  const letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  return letters[index] || '';
};

function Questoes() {
  const [tenantId, setTenantId] = useState(localStorage.getItem('tenantId') || '');

  useEffect(() => {
    if (!tenantId) {
      console.error('Erro: tenantId não encontrado no localStorage.');
      setTenantId('defaultTenantId'); // Fallback para um ID padrão se não encontrado
    }
  }, [tenantId]);

  const [formData, setFormData] = useState({
    enunciado: '',
    options: [
      { text: '', isCorrect: false, justificativa: '' },
      { text: '', isCorrect: false, justificativa: '' },
    ],
    difficulty: '',
    temas: [],
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
    dataexpiracao: '',
    enviado: false,
    bloqueado: false,
    prioridade: null,
    tenantId: tenantId,
    type: 'quiz', // Ajustado para 'type'
  });

  const [selectedQuestao, setSelectedQuestao] = useState(null);
  const [isCreating, setIsCreating] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [searchQuery, setSearchQuery] = useState('');
  const [questoes, setQuestoes] = useState([]);
  const [filteredQuestoes, setFilteredQuestoes] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(ITEMS_PER_PAGE_OPTIONS[0]);
  const [isLoading, setIsLoading] = useState(false);
  const [isImporting, setIsImporting] = useState(false);
  const [temas, setTemas] = useState([]);
  const [isProcessingQueue, setIsProcessingQueue] = useState(false);

  useEffect(() => {
    fetchQuestoes();
    fetchTemas();
  }, []);

  // Lógica para carregar a questão selecionada no formulário
  useEffect(() => {
    if (selectedQuestao) {
      let loadedOptions = selectedQuestao.options || [];

      // Acessa selectedQuestao.type
      if (selectedQuestao.type === 'pesquisa_dissertativa' || selectedQuestao.type === 'pesquisa_multipla_escolha') {
        if (!loadedOptions.length || loadedOptions.every(opt => opt.text.trim() === '')) {
          loadedOptions = [];
        }
      }
      
      // Acessa selectedQuestao.type
      if (
        (selectedQuestao.type === 'quiz' || selectedQuestao.type === 'pesquisa_multipla_escolha') &&
        loadedOptions.length === 0
      ) {
        loadedOptions = [
          { text: '', isCorrect: false, justificativa: '' },
          { text: '', isCorrect: false, justificativa: '' },
        ];
      }

      setFormData((prevData) => ({
        ...prevData,
        ...selectedQuestao,
        options: loadedOptions,
        type: selectedQuestao.type || selectedQuestao.tipo || 'quiz', // Fallback para 'tipo' caso seja uma questão antiga
      }));
    } else {
      resetFormData();
    }
  }, [selectedQuestao]);

  useEffect(() => {
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    setFilteredQuestoes(questoes.slice(startIndex, endIndex));
    setTotalPages(Math.ceil(questoes.length / itemsPerPage));
  }, [currentPage, questoes, itemsPerPage]);


  const fetchQuestoes = async () => {
    setIsLoading(true);
    try {
      const querySnapshot = await getDocs(collection(firestore, 'questoes'));
      const questoesData = querySnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));

      const sortedQuestoes = questoesData.sort((a, b) => (a.prioridade || 0) - (b.prioridade || 0));
      setQuestoes(sortedQuestoes);
      applySearchFilter(searchQuery, sortedQuestoes);
    } catch (error) {
      console.error('Erro ao buscar questões:', error);
      setError('Houve um problema ao buscar as questões.');
    } finally {
      setIsLoading(false);
    }
  };

  const fetchTemas = async () => {
    try {
      const querySnapshot = await getDocs(collection(firestore, 'temas'));
      const temasData = querySnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
      setTemas(temasData);
    } catch (error) {
      console.error('Erro ao buscar temas:', error);
      setError('Houve um problema ao buscar os temas.');
    }
  };

  const resetFormData = () => {
    setFormData({
      enunciado: '',
      options: [
        { text: '', isCorrect: false, justificativa: '' },
        { text: '', isCorrect: false, justificativa: '' },
      ],
      difficulty: '',
      temas: [],
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
      dataexpiracao: '',
      enviado: false,
      bloqueado: false,
      prioridade: null,
      tenantId: tenantId,
      type: 'quiz', // Ajustado para 'type'
    });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
    setError('');
  };

  // =================================================================
  //          *** FUNÇÃO CORRIGIDA ***
  // =================================================================
  const handleOptionChange = (index, field, value) => {
    // Começa com uma cópia das opções
    let newOptions = [...formData.options];

    // Atualiza o campo específico que mudou
    newOptions[index] = { ...newOptions[index], [field]: value };

    // Se for um quiz, aplica a lógica de "apenas uma resposta correta"
    if (formData.type === 'quiz') {
      if (field === 'isCorrect' && value) {
        // Se uma caixa foi marcada, desmarca todas as outras
        newOptions = newOptions.map((opt, i) => {
          if (i !== index) {
            return { ...opt, isCorrect: false };
          }
          return opt;
        });
      }
      
      // Se uma caixa foi desmarcada, limpa sua justificativa
      if (field === 'isCorrect' && !value) {
        newOptions[index].justificativa = '';
      }
    } else {
      // Se não for um quiz, nenhuma opção pode ser correta e as justificativas são limpas
      newOptions = newOptions.map(opt => ({ ...opt, isCorrect: false, justificativa: '' }));
    }

    setFormData((prevData) => ({ ...prevData, options: newOptions }));
  };

  const handleJustificativaChange = (index, value) => {
    const newOptions = [...formData.options];
    newOptions[index] = { ...newOptions[index], justificativa: value };
    setFormData((prevData) => ({ ...prevData, options: newOptions }));
  };

  const addOption = () => {
    setFormData((prevData) => ({
      ...prevData,
      options: [...prevData.options, { text: '', isCorrect: false, justificativa: '' }],
    }));
  };

  const removeOption = (index) => {
    setFormData((prevData) => {
      const newOptions = prevData.options.filter((_, i) => i !== index);
      return { ...prevData, options: newOptions };
    });
  };

  const handleSubmit = async () => {
    const trimmedEnunciado = formData.enunciado.trim();

    if (
      !trimmedEnunciado ||
      !formData.type
    ) {
      setError('Por favor, preencha o Enunciado e selecione o Tipo de Questão (*).');
      return;
    }

    if (formData.type === 'quiz') {
        if (
            !formData.difficulty ||
            formData.temas.length === 0
        ) {
            setError('Para questões do tipo Quiz, por favor, preencha a Dificuldade e selecione pelo menos um Tema (*).');
            return;
        }

        if (formData.options.length < 2 || formData.options.some((o) => !o.text.trim())) {
            setError('Para questões do tipo Quiz, são necessárias pelo menos duas alternativas preenchidas.');
            return;
        }
        const hasCorrectOption = formData.options.some(opt => opt.isCorrect);
        if (!hasCorrectOption) {
            setError('Para questões do tipo Quiz, uma alternativa correta deve ser marcada.');
            return;
        }
    }

    const timestamp = Timestamp.now();
    let optionsToSave = [];

    if (formData.type === 'quiz' || formData.type === 'pesquisa_multipla_escolha') {
      optionsToSave = formData.options
        .filter(opt => opt.text.trim() !== '')
        .map(opt => ({
          text: opt.text.trim(),
          isCorrect: formData.type === 'quiz' ? opt.isCorrect : false,
          justificativa: formData.type === 'quiz' ? opt.justificativa.trim() : '',
        }));
    }

    const dataToSave = { ...formData };
    if (dataToSave.hasOwnProperty('tipo')) {
      delete dataToSave.tipo;
    }

    const updatedData = {
      ...dataToSave,
      enunciado: trimmedEnunciado,
      options: optionsToSave,
      updatedAt: timestamp,
      tenantId: tenantId,
      ...(formData.type !== 'quiz' && { difficulty: '', temas: [] }),
    };

    try {
      if (selectedQuestao?.id) {
        await updateDoc(doc(firestore, 'questoes', selectedQuestao.id), updatedData);
      } else {
        await setDoc(doc(firestore, 'questoes', new Date().getTime().toString()), {
          ...updatedData,
          createdAt: timestamp,
        });
      }
      setSuccess('Questão salva com sucesso!');
      resetFormData();
      setSelectedQuestao(null);
      setIsCreating(false);
      setTimeout(() => setSuccess(''), 3000);
      await fetchQuestoes();
    } catch (error) {
      console.error('Erro ao salvar questão:', error);
      setError('Houve um problema ao salvar a questão. Por favor, tente novamente.');
    }
  };


  const handleSearch = (e) => {
    const searchText = e.target.value;
    setSearchQuery(searchText);
    applySearchFilter(searchText, questoes);
  };

  const applySearchFilter = (searchText, questoesData) => {
    const filteredData = questoesData.filter(
      (questao) =>
        questao.enunciado.toLowerCase().includes(searchText.toLowerCase()) ||
        questao.id.includes(searchText)
    );
    setTotalPages(Math.ceil(filteredData.length / itemsPerPage));
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    setFilteredQuestoes(filteredData.slice(startIndex, endIndex));
  };

  const handleEdit = (questao) => {
    setSelectedQuestao(questao);
    setIsCreating(true);
  };

  const handleDelete = async (id) => {
    try {
      await deleteDoc(doc(firestore, 'questoes', id));
      await fetchQuestoes();
      setSuccess('Questão excluída com sucesso!');
      setTimeout(() => setSuccess(''), 3000);
    } catch (error) {
      console.error('Erro ao excluir questão:', error);
      setError('Houve um problema ao excluir a questão. Por favor, tente novamente.');
    }
  };

  const handlePageChange = (direction) => {
    if (direction === 'next' && currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    } else if (direction === 'previous' && currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleItemsPerPageChange = (e) => {
    setItemsPerPage(Number(e.target.value));
    setCurrentPage(1);
  };

  const handleImportClick = () => {
    setIsImporting(true);
  };

  const handleImportComplete = () => {
    setIsImporting(false);
    fetchQuestoes();
  };

  const aumentarPrioridade = async (questaoId, prioridadeAtual) => {
    const newPrioridade = Math.max(1, (prioridadeAtual || 0) - 1);
    try {
      await updateDoc(doc(firestore, 'questoes', questaoId), {
        prioridade: newPrioridade,
      });
      fetchQuestoes();
    } catch (error) {
      console.error('Erro ao atualizar prioridade:', error);
      setError('Houve um problema ao atualizar a prioridade.');
    }
  };

  const diminuirPrioridade = async (questaoId, prioridadeAtual) => {
    const newPrioridade = (prioridadeAtual || 0) + 1;
    try {
      await updateDoc(doc(firestore, 'questoes', questaoId), {
        prioridade: newPrioridade,
      });
      fetchQuestoes();
    } catch (error) {
      console.error('Erro ao atualizar prioridade:', error);
      setError('Houve um problema ao atualizar a prioridade.');
    }
  };

  const handleProcessQueue = () => {
    setIsProcessingQueue(true);
  };

  const closeProcessQueueModal = () => {
    setIsProcessingQueue(false);
  };

  return (
    <div className="questoes-container">
      <div className="header-container">
        <h1>Gerenciador de Questões</h1>
        {!isCreating && !isImporting && (
          <div className="action-buttons">
            <button onClick={() => setIsCreating(true)} className="add-button">
              Adicionar
            </button>
            <button onClick={handleImportClick} className="import-button">
              Importar
            </button>
            <button onClick={handleProcessQueue} className="add-button">
              Processar Fila
            </button>
          </div>
        )}
        {!isCreating && !isImporting && (
          <div className="search-and-filter">
            <input
              type="text"
              placeholder="Buscar por pergunta..."
              value={searchQuery}
              onChange={handleSearch}
              className="search-input"
            />
          </div>
        )}
      </div>

      {isCreating && (
        <div className="questao-form-container">          
          <h2>{selectedQuestao ? 'Editar Questão' : 'Adicionar Nova Questão'}</h2>
          {error && <div className="form-feedback form-error">{error}</div>}
          {success && <div className="form-feedback form-success">{success}</div>}

          <div className="form-group">
            <label htmlFor="type">Tipo de Pergunta *</label>
            <select
              id="type"
              name="type"
              value={formData.type}
              onChange={handleChange}
              required
            >
              <option value="quiz">Quiz</option>
              <option value="pesquisa_dissertativa">Pesquisa (Dissertativa)</option>
              <option value="pesquisa_multipla_escolha">Pesquisa (Múltipla Escolha)</option>
            </select>
          </div>

          <div className="form-group">
            <label htmlFor="enunciado">Enunciado *</label>
            <textarea
              id="enunciado"
              name="enunciado"
              value={formData.enunciado}
              onChange={handleChange}
              required
              className="textarea-custom"
            />
          </div>

          {formData.type === 'quiz' && (
            <div className="form-group">
              <label htmlFor="difficulty">Dificuldade *</label>
              <select
                id="difficulty"
                name="difficulty"
                value={formData.difficulty}
                onChange={handleChange}
                required
              >
                <option value="">Selecione</option>
                <option value="Fácil">Fácil</option>
                <option value="Médio">Média</option>
                <option value="Difícil">Difícil</option>
              </select>
            </div>
          )}

          {formData.type === 'quiz' && (
            <div className="form-group">
              <label htmlFor="temas">Tema(s) *</label>
              <select
                id="temas"
                name="temas"
                multiple
                value={formData.temas}
                onChange={(e) =>
                  setFormData((prevData) => ({
                    ...prevData,
                    temas: Array.from(e.target.selectedOptions, (option) => option.value),
                  }))
                }
                required
              >
                {temas.map((tema) => (
                  <option key={tema.id} value={tema.id}>
                    {tema.nome}
                  </option>
                ))}
              </select>
            </div>
          )}

          {(formData.type === 'quiz' || formData.type === 'pesquisa_multipla_escolha') && (
            <>
              <div className="alternativas-container">
                {formData.options.map((option, index) => (
                  <div className="form-group" key={index}>
                    <label htmlFor={`option_${index}_text`}>
                      Alternativa {getOptionLetter(index)} {formData.type === 'quiz' ? '*' : ''}
                    </label>
                    <input
                      id={`option_${index}_text`}
                      name={`option_${index}_text`}
                      type="text"
                      value={option.text}
                      onChange={(e) => handleOptionChange(index, 'text', e.target.value)}
                      required={formData.type === 'quiz'}
                    />

                    {formData.type === 'quiz' && (
                      <label className="checkbox-label">
                        <input
                          type="checkbox"
                          name={`option_${index}_isCorrect`}
                          checked={option.isCorrect}
                          onChange={(e) => handleOptionChange(index, 'isCorrect', e.target.checked)}
                        />
                        <span>Correta</span>
                      </label>
                    )}

                    {formData.type === 'quiz' && option.isCorrect && (
                      <label className="textarea-container">
                        Justificativa:
                        <textarea
                          className="textarea-custom"
                          value={option.justificativa}
                          onChange={(e) => handleJustificativaChange(index, e.target.value)}
                        />
                      </label>
                    )}
                    {(formData.options.length > (formData.type === 'quiz' ? 2 : 0)) && (
                      <button type="button" onClick={() => removeOption(index)}>
                        Remover Alternativa
                      </button>
                    )}
                  </div>
                ))}
              </div>

              <button type="button" onClick={addOption}>
                Adicionar Alternativa
              </button>
            </>
          )}

          <div className="form-group">
            <label htmlFor="dataexpiracao">Data de Expiração</label>
            <input
              type="date"
              id="dataexpiracao"
              name="dataexpiracao"
              value={formData.dataexpiracao}
              onChange={handleChange}
            />
          </div>

          <div className="button-group">
            <button type="button" onClick={handleSubmit}>
              {selectedQuestao ? 'Atualizar Questão' : 'Adicionar Questão'}
            </button>
            <button
              type="button"
              className="cancel-button"
              onClick={() => {
                setIsCreating(false);
                setSelectedQuestao(null);
                setError('');
                setSuccess('');
              }}
            >
              Cancelar
            </button>
          </div>
        </div>
      )}

      {!isCreating && !isImporting && (
        <div className="">
          {isLoading ? (
            <div className="loading-container">
              <Carregando />
            </div>
          ) : questoes.length > 0 ? (
            // A lista aplica a busca, os filtros (curso, tema, pesquisas) e a paginação
            <QuestaoList busca={searchQuery} onEdit={handleEdit} onDelete={handleDelete} />
          ) : (
            <p>Nenhuma questão encontrada.</p>
          )}
        </div>
      )}

      {isImporting && <ImportQuestoes onClose={handleImportComplete} />}

      <Modal
        isOpen={isProcessingQueue}
        onRequestClose={closeProcessQueueModal}
        contentLabel="Processar Fila"
        className="simulador-modal"
        overlayClassName="simulador-overlay"
        style={{
          content: {
            position: 'fixed',
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            zIndex: '1000',
            backgroundColor: '#f8f9fa',
            padding: '30px',
            borderRadius: '12px',
            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
            maxWidth: '400px',
            width: '90%',
          },
          overlay: {
            backgroundColor: 'rgba(0, 0, 0, 0.7)',
          },
        }}
      >
        <Simulador onCancel={closeProcessQueueModal} />
      </Modal>
    </div>
  );
}

export default Questoes;